export function mergeBoothLabels(booths) {
	if (booths.length === 1) {
		return `${booths[0].hall.name}/${booths[0].no}`;
	}

	const infos = booths.map((booth) => ({ hall: booth.hall.name, no: booth.no }));
	infos.sort((a, b) => {
		if (a.hall > b.hall) {
			return 1;
		}
		if (a.hall < b.hall) {
			return -1;
		}
		return a.no - b.no;
	});

	const groups = [[infos[0]]];
	let groupIndex = 0;

	for (let i = 1; i < infos.length; i++) {
		const prev = infos[i - 1];
		const current = infos[i];

		if (current.hall !== prev.hall) {
			groups.push([current]);
			groupIndex++;
		} else if (current.no - prev.no > 1) {
			groups.push([current]);
			groupIndex++;
		} else {
			groups[groupIndex][1] = current;
		}
	}

	const finalGroups = [];
	groups.forEach((group) => {
		if (group.length > 1 && group[1].no - group[0].no === 1) {
			finalGroups.push([group[0]], [group[1]]);
		} else {
			finalGroups.push(group);
		}
	});

	return finalGroups.map((group) => group.map((item) => `${item.hall}/${item.no}`).join('-')).join(', ');
}
